import { request } from '@/utils/request'

export interface IDeleteBody {
  __type: string,
  __uuid: string
  __adapter?: string
}

export const deleteBundle = (body: IDeleteBody) => {
  return request('/api/node/delete', {
    method: 'POST',
    body: JSON.stringify(body)
  })
}
